module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jill Kemerer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Jill Kemerer ")]), _vm._v("is a Publishers Weekly bestselling author of Christian romance novels. Her essentials include coffee, a stack of books, her mini-dachshund, and taking long nature walks. Jill resides in Ohio with her husband and two almost-grown children. She loves connecting with readers, so please visit her website, jillkemerer.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xg1Gjy/tc-custom/9781488060090.jpg?1701952905494",
      "alt": "This image is the cover for the book Cowboy's Secret, Wyoming Sweethearts"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cowboy's Secret, Wyoming Sweethearts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A millionaire in disguise is out to prove he’s worthy of his niece’s beautiful guardian in this wholesome contemporary Western romance.")]), _c('br'), _c('br'), _vm._v("Gabby Stover has learned from experience that most people can’t be trusted—especially when it comes to cowboys. Now that she finds herself raising her sister’s daughter in Rendezvous, Wyoming, Gabby is fiercely independent—and determined to give little Phoebe a better childhood than she had."), _c('br'), _c('br'), _vm._v("Dylan Kingsley has learned to hide his millionaire status from strangers. So when he shows up in Rendezvous looking for his stepbrother’s daughter, Gabby takes him for just another drifter. But Dylan is determined to win Gabby’s trust—so much so that he takes a job as a ranch hand. In the process, he just might finds the purpose—and the family—he’s been searching for.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0